import React from 'react';
import {getSvgComponent} from '../../utils/svgLoader';
import styles from './Icon.module.css';

export interface IconProps {
  name: string;
  className?: string;
}

function extractOriginalName(path: string): string | null {
  const match = path.match(/\/([^/]+?)\.[a-f0-9]{32}\.svg$/);
  return match ? `${match[1]}.svg` : null;
}

export const Icon: React.FC<IconProps> = ({name, className}) => {
  const isSvgFile = /\.svg$/i.test(name);
  const fileName = isSvgFile ? name : `${name}.svg`;

  let SvgIcon = getSvgComponent(fileName);
  if (!SvgIcon) {
    {
      SvgIcon = getSvgComponent(extractOriginalName(name) ?? '');
    }
  }

  if (isSvgFile) {
    if (SvgIcon) {
      return <SvgIcon className={`${styles.svg} ${className ?? ''}`} />;
    } else {
      return <img src={name} className={className ?? ''} />;
    }
  }

  return <span className={`${name} ${className ?? ''}`} />;
};
